// components/Timeline.jsx - 时间轴组件
import React from 'react';

export function Timeline({ items, onItemClick, selectedExperience, selectedProject }) {
  // 将日期格式化为年月
  const formatDate = (dateObj) => {
    const date = new Date(dateObj);
    return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}`;
  };

  // 按年份分组项目
  const groupByYear = (items) => {
    const groups = {};
    
    items.forEach(item => {
      const year = new Date(item.date).getFullYear();
      if (!groups[year]) {
        groups[year] = [];
      }
      groups[year].push(item);
    });
    
    // 转换为数组并按年份降序排序
    return Object.entries(groups)
      .map(([year, yearItems]) => ({
        year: parseInt(year),
        items: yearItems.sort((a, b) => b.date - a.date) // 年内按日期降序排列
      }))
      .sort((a, b) => b.year - a.year); // 年份降序排列
  };

  const yearGroups = groupByYear(items);

  return (
    <div className="timeline">
      <h2 className="timeline-title">职业发展时间轴</h2>
      
      {yearGroups.map(({ year, items }) => (
        <div key={year} className="timeline-year-group">
          <div className="timeline-year">{year}</div>
          
          <div className="timeline-items">
            {items.map(item => {
              const isExperience = item.type === 'experience';
              const isProject = item.type === 'project';
              const isSelected = 
                (isExperience && selectedExperience?.id === item.id) || 
                (isProject && selectedProject?.id === item.id);
              
              return (
                <div 
                  key={`${item.type}-${item.id}`} 
                  className={`timeline-item ${item.type} ${isSelected ? 'selected' : ''}`}
                  onClick={() => onItemClick(item)}
                >
                  <div 
                    className="timeline-item-dot" 
                    style={{ backgroundColor: item.color || '#999' }}
                  />
                  
                  <div className="timeline-item-content">
                    <div className="timeline-item-header">
                      <span className="timeline-item-date">
                        {formatDate(item.date)}
                        {isExperience && item.endDate 
                          ? ` - ${item.endDate ? formatDate(item.endDate) : '至今'}`
                          : ''
                        }
                      </span>
                      <span className="timeline-item-type">
                        {isExperience ? '经历' : '项目'}
                      </span>
                    </div>
                    
                    <h3 className="timeline-item-title">
                      {isExperience ? item.company : item.name}
                    </h3>
                    
                    <p className="timeline-item-subtitle">
                      {isExperience ? item.title : item.description}
                    </p>
                    
                    {isExperience && (
                      <div className="timeline-item-skills">
                        {item.skills.map((skill, index) => (
                          <span key={index} className="timeline-skill-tag">{skill}</span>
                        ))}
                      </div>
                    )}
                    
                    {isProject && (
                      <div className="timeline-item-skills">
                        {item.technologies.map((tech, index) => (
                          <span key={index} className="timeline-skill-tag">{tech}</span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
} 